import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PET_RAKUNORI_STORE_NAME, PetRakunoriState } from './pet-rakunori.state';

/** Select PetRakunori State */
export const selectPetRakunoriState = createFeatureSelector<PetRakunoriState>(PET_RAKUNORI_STORE_NAME);

/** Select PetRakunori isPending status */
export const selectPetRakunoriIsPendingStatus = createSelector(selectPetRakunoriState, (state) => !!state.isPending);

/** Select PetRakunori isFailure status */
export const selectPetRakunoriIsFailureStatus = createSelector(selectPetRakunoriState, (state) => !!state.isFailure);
